/**
 *  Created By Taesoo.Kim <devp015>
 */

import {SystemApiPrefix as sysApiPrefix} from 'utils'
import {pcDownloadFile} from '~/utils/files'

export const state = () => ({
  deviceDelPeriodUrl: `${sysApiPrefix}/general`, // 보관일수
  backUpUrl: `${sysApiPrefix}/backup-sched`, // 백업 일정 추가, 수정
  backUpDeleteUrl: `${sysApiPrefix}/backup-sched-multi`, // 백업 일정 삭제
  backUpFileUrl: `${sysApiPrefix}/backup/file`, // 로컬 백업 파일 삭제
  backUpDownloadUrl: `${sysApiPrefix}/backup/file/download`, // 로컬 백업 파일 다운로드
  backUpUploadUrl: `${sysApiPrefix}/backup/file/upload`, // 로컬 백업 파일 업로드
  backUpManualUrl: `${sysApiPrefix}/backup_manual`, // 수동 백업 실행
  backUpRestoreUrl: `${sysApiPrefix}/restore_manual`, // 복구 시작
  backUpUnzipUrl: `${sysApiPrefix}/unzip_restore_file`, // 압축 해제,
  backUpApplyUrl: `${sysApiPrefix}/backup-sched/apply`,
  backUpCancelUrl: `${sysApiPrefix}/backup-sched/cancel`,

  delPeriodData: 60,
  getLocalBackupSchedData: [],
  setBackupSchedData: {
    backup_item_set: [],
    backup_pw: '',
    backup_sched_type: 1,
    backup_sched_set: {},
    backup_sched_uname: '',
    // 원격 백업
    backup_sched_remote_prtc: 2,
    backup_sched_remote_port: 22,
    backup_sched_remote_svr_ip: '',
    backup_sched_remote_path_val: '',
    backup_sched_remote_login_name: '',
    backup_sched_remote_login_pw: ''
  },
  clearBackupSchedData: {
    backup_item_set: [],
    backup_pw: '',
    backup_sched_type: 1,
    backup_sched_set: {},
    backup_sched_uname: '',
    // 원격 백업
    backup_sched_remote_prtc: 2,
    backup_sched_remote_port: 22,
    backup_sched_remote_svr_ip: '',
    backup_sched_remote_path_val: '',
    backup_sched_remote_login_name: '',
    backup_sched_remote_login_pw: ''
  },
  getRemoteBackupSchedData: [],
  getBackupFileData: [],
  setManualBackupData: {
    backup_item_set: [],
    backup_pw: '',
    id: 1
  },
  getBackupFileDownloadData: {
    backup_file_id_list: []
  },
  delBackupFileData: {
    backup_file_id_list: []
  },
  setBackupRestoreData: {
    restore_item_set: []
  },
  setBackupRestorePwdData: {
    backup_file_id: 1,
    backup_pw: ''
  },
  resultMsg: {}
})

export const mutations = {
  getBackupSchedDataAction (state, data) {
    if (data.type === 1) {
      state.getLocalBackupSchedData = data.result
    } else if (data.type === 2) {
      state.getRemoteBackupSchedData = data.result
    }
  },
  getBackupFileDataAction (state, data) {
    state.getBackupFileData = data
  },
  getDelPeriodDataAction (state, data) {
    state.delPeriodData = _.cloneDeep(data.msg)
  },
  clearBackupSchedDataAction (state, data) {
    state.setBackupSchedData = _.cloneDeep(data)
  },
  setResultMsgData (state, data) {
    state.resultMsg = data.msg
  }
}

export const actions = {
  async getDelPeriodDataAction ({commit, state}) {
    let bRet = false

    const apiUrl = `${state.deviceDelPeriodUrl}?key=system.backup.delete_term`

    const data = await this.$axios.$get(apiUrl)
    if (data.code === 'ok') {
      commit('getDelPeriodDataAction', data.result)
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async setDelPeriodDataAction ({commit, state}, periodData) {
    let bRet = false

    const param = {
      key: 'system.backup.delete_term',
      val: periodData
    }
    const data = await this.$axios.$put(`${state.deviceDelPeriodUrl}`, param, {successAlert: false})

    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async getBackupSchedDataAction ({commit, state}, param) {
    let bRet = false
    let apiUrl = `${state.backUpUrl}/${param.backup_sched_type}`
    if (param.devicebackup_sched_id > -1) {
      apiUrl += `/${param.devicebackup_sched_id}`
    }
    const data = await this.$axios.$get(apiUrl)
    if (data.code === 'ok') {
      commit('getBackupSchedDataAction',
        {
          type: param.backup_sched_type,
          result: data.result
        }
      )
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async setBackupSchedDataAction ({commit, state}, txtFlg) {
    let bRet = false
    let data = {}
    if (txtFlg === 'add') {
      data = await this.$axios.$post(`${state.backUpUrl}`, state.setBackupSchedData)
    } else if (txtFlg === 'edit') {
      data = await this.$axios.$put(`${state.backUpUrl}`, state.setBackupSchedData)
    }
    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async delBackupDataAction ({commit, state}, item) {
    let bRet = false
    let data = ''
    if (item.backup_sched_id_list) {
      data = await this.$axios.$delete(`${state.backUpDeleteUrl}`,
        {data: item},
        {
          failAlert: false
        }
      )
    } else if (item.backup_file_id_list) {
      data = await this.$axios.$put(`${state.backUpFileUrl}`, item, {successAlert: false})
    }

    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async getBackupFileDataAction ({commit, state}, param) {
    let bRet = false
    const apiUrl = `${state.backUpFileUrl}/${param.id}`
    const data = await this.$axios.$get(apiUrl)
    if (data.code === 'ok') {
      commit('getBackupFileDataAction', data.result)
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async setManualBackupFileDataAction ({commit, state}) {
    let bRet = false
    const data = await this.$axios.$post(`${state.backUpManualUrl}`, state.setManualBackupData)
    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async setRestoreBackupFileDataAction ({commit, state}) {
    const data = await this.$axios.$post(`${state.backUpRestoreUrl}`, state.setBackupRestoreData, {successAlert: false})
    return data
  },
  async setRestoreBackupFilePwdDataAction ({commit, state}) {
    let bRet = false
    const data = await this.$axios.$post(`${state.backUpUnzipUrl}`, state.setBackupRestorePwdData)
    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async uploadBackupFileAction ({commit, state}, formData) {
    let bRet = false
    const data = await this.$axios.$post(`${state.backUpUploadUrl}`, formData)
    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async downloadBackupFileAction ({commit, state}, fileList) {
    let bRet = false
    try {
      const result = await this.$axios.$file(`${state.backUpDownloadUrl}`, fileList, {
        responseType: 'blob',
        method: 'post',
        successAlert: false,
        returnErr: true
      })
      if (result.code !== undefined) {
        const blob = new Blob([result.data])
        const reader = new FileReader()
        const _this = this
        reader.onload = () => {
          const msgObj = JSON.parse(reader.result)
          const msgTxt = msgObj.result.msg
          _this.$router.app.$alertPopUp.show(msgTxt)
        }
        reader.readAsText(blob)
      } else {
        const nameData = result.fileName.replace('UTF-8\'\'', '')
        pcDownloadFile(result.data, nameData)
      }
      bRet = true
    } catch (e) {
      bRet = false
    }
    return bRet
  },
  async applyDeviceBackUpAction ({commit, state}, param) {
    let bRet = false
    let data = ''
    if (param === 'apply') {
      data = await this.$axios.$put(`${state.backUpApplyUrl}`, '', {applyMsg: true})
    } else {
      data = await this.$axios.$put(`${state.backUpCancelUrl}`, '', {cancelMsg: true})
    }
    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  }
}

export const getters = {
  compareEditData () {
    return false
  }
}

export const strict = false
